__turbopack_context__.v({
  "closeButton": "SendCallbackModal-module-scss-module__Z5sema__closeButton",
  "confirmButton": "SendCallbackModal-module-scss-module__Z5sema__confirmButton",
  "fadeIn": "SendCallbackModal-module-scss-module__Z5sema__fadeIn",
  "modalHeader": "SendCallbackModal-module-scss-module__Z5sema__modalHeader",
  "modalSubtitle": "SendCallbackModal-module-scss-module__Z5sema__modalSubtitle",
  "modalTitle": "SendCallbackModal-module-scss-module__Z5sema__modalTitle",
  "modalWindow": "SendCallbackModal-module-scss-module__Z5sema__modalWindow",
  "overlay": "SendCallbackModal-module-scss-module__Z5sema__overlay",
  "recaptchaWrapper": "SendCallbackModal-module-scss-module__Z5sema__recaptchaWrapper",
  "safeArea": "SendCallbackModal-module-scss-module__Z5sema__safeArea",
  "scaleIn": "SendCallbackModal-module-scss-module__Z5sema__scaleIn",
  "slideUp": "SendCallbackModal-module-scss-module__Z5sema__slideUp",
  "spin": "SendCallbackModal-module-scss-module__Z5sema__spin",
  "spinner": "SendCallbackModal-module-scss-module__Z5sema__spinner",
  "successButton": "SendCallbackModal-module-scss-module__Z5sema__successButton",
  "successIcon": "SendCallbackModal-module-scss-module__Z5sema__successIcon",
});
